(function () {
  if (!window.DIAGNOSES_DATA || !Array.isArray(window.DIAGNOSES_DATA.diagnoses)) {
    console.error("❌ DIAGNOSES_DATA not found");
    return;
  }

  const root = document.getElementById("diagnosis-root");
  if (!root) {
    console.error("❌ diagnosis-root element not found");
    return;
  }

  const diagnoses = window.DIAGNOSES_DATA.diagnoses;

  root.innerHTML = `
    <div class="diagnosis-accordion">
      ${diagnoses.map(d => `
        <div class="diag-item" id="${d.slug}">
          <button class="diag-toggle" aria-expanded="false">
            ${d.term}
          </button>

          <div class="diag-content">
            ${d.definition ? `<p><strong>Definícia:</strong> ${d.definition}</p>` : ""}

            ${d.clinical_context ? `<p><strong>Klinický kontext:</strong> ${d.clinical_context}</p>` : ""}

            ${d.relation_to_gait ? `<p><strong>Vplyv na chôdzu:</strong> ${d.relation_to_gait}</p>` : ""}

            ${d.who_is_affected ? `<p><strong>Koho postihuje:</strong> ${d.who_is_affected}</p>` : ""}

            ${d.internal_link ? `
              <p>
                <a href="${d.internal_link}">
                  Viac o tomto probléme →
                </a>
              </p>
            ` : ""}

            ${d.recommended_products.length ? `
              <h4>Odporúčané vložky MEDICOVI</h4>
              <ul class="recommended-products">
                ${d.recommended_products.map(p => `
                  <li>
                    <a href="/products/${p.handle}">
                      ${p.handle.toUpperCase()}
                    </a>
                    <small>(${p.support_level}, ${p.usage})</small>
                  </li>
                `).join("")}
              </ul>
            ` : ""}

            ${d.citations.length ? `
              <h4>Odborné zdroje</h4>
              <ul>
                ${d.citations.map(c => `
                  <li>
                    <a href="${c.url}" target="_blank" rel="nofollow noopener">
                      ${c.title} – ${c.journal} (${c.year})
                    </a>
                  </li>
                `).join("")}
              </ul>
            ` : ""}

            <p class="medical-disclaimer">
              Informácie slúžia na edukačné účely a nenahrádzajú lekársku starostlivosť.
            </p>
          </div>
        </div>
      `).join("")}
    </div>
  `;

  /* =========================
     ACCORDION LOGIC
  ========================= */
  const items = root.querySelectorAll(".diag-item");

  items.forEach(item => {
    const btn = item.querySelector(".diag-toggle");

    btn.addEventListener("click", () => {
      items.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
          i.querySelector(".diag-toggle")?.setAttribute("aria-expanded", "false");
        }
      });

      const isOpen = item.classList.toggle("active");
      btn.setAttribute("aria-expanded", isOpen);
    });
  });

})();